import React, { forwardRef, memo } from 'react'

const LinkIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="29.4"
      height="29.4"
      viewBox="0 0 42 42"
      fill="none"
      {...props}>
      <path
        d="M32.7041 9.74438L9.74487 32.7036"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9338 17.3976C15.3993 17.3976 17.3981 15.3988 17.3981 12.9333C17.3981 10.4677 15.3993 8.46899 12.9338 8.46899C10.4682 8.46899 8.46948 10.4677 8.46948 12.9333C8.46948 15.3988 10.4682 17.3976 12.9338 17.3976Z"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5153 33.9791C31.9809 33.9791 33.9796 31.9804 33.9796 29.5148C33.9796 27.0493 31.9809 25.0505 29.5153 25.0505C27.0498 25.0505 25.051 27.0493 25.051 29.5148C25.051 31.9804 27.0498 33.9791 29.5153 33.9791Z"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

LinkIcon.displayName = 'LinkIcon'

export default memo(LinkIcon)
